/**
 * Sample study topics use `{week}.{indexWithinWeek}` (e.g. `1.2` = week 1, second item).
 * Must match files in `json/` and keys in the registry.
 */
/** Stored in `content_feedback.plan_context` for sample-study feedback (not a real upskill plan). */
export const SAMPLE_PLAN_FEEDBACK_CONTEXT = 'sample_plan';

export const DEFAULT_SAMPLE_TOPIC_KEY = '1.1';

export const SAMPLE_TOPIC_KEYS = [
  '1.1', '1.2', '1.3', '1.4', '1.5',
  '2.1', '2.2', '2.3', '2.4', '2.5',
] as const;

export type SampleTopicKey = (typeof SAMPLE_TOPIC_KEYS)[number];
